import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const PlayerContext = createContext<{
  params?: Routing.PlayerParams
}>({})

export { PlayerContext }
